<div class="footer-left-container">
    <a target="_blank" href="{{vertaforeUrl}}">
        <img class="footer-logo" src="/images/vertafore-logo-black.svg" alt="Vertafore Home Page">
        <span class="footer-link">
            &copy; {{ date | date:'yyyy' }} Vertafore, Inc. All rights reserved.
        </span>
    </a>
    <span class="left-group">
        @if (showTermsOfService()) {
            <button type="button" class="button-link" (click)="openDialog('terms-of-service')">Terms & Conditions</button>
        }
        <a href="https://www.vertafore.com/product-privacy-statement" target="_blank" rel="noopener noreferrer">Privacy Statement</a>
        @if (showEarlyAdopterProgramTerms()) {
            <a href="https://www.vertafore.com/early-adopter-program-terms" target="_blank"
               rel="noopener noreferrer">Early Adopter Program Terms</a>
        }
    </span>
</div>
<div class="footer-right-container">
    <span [hidden]="!isStateInfoCenterAvailable()">
        <a class="state-info-center" target="_blank" href="{{stateInfoCenterUrl}}">State Information Center</a>
        <span class="footer-separator">|</span>
    </span>

    <button [hidden]="!isTourAvailable()" type="button" class="button-link" (click)="openDialog('tour-dialog')">Take a
        Tour
    </button>
    @if (isHelpLinkAvailable()) {
        <span [hidden]="!isTourAvailable()" class="footer-separator">|</span>
    }

    <!-- Cannot use the help directive here because the footer is not explicitly defined in routes.js for each route
         This means that the directive would not update with the new URL on state change
     -->

    @if (isHelpLinkAvailable()) {
        <a target="_blank" href="{{helpUrl()}}">
            <fa-icon [icon]="faCircleQuestion" aria-hidden="true"></fa-icon>
            Help</a>
    }

    <span [hidden]="!isLiveChatAvailable()">
        <span class="footer-separator">|</span>
        <!--The CSS style is inline here because of the limitations of the live chat library-->
        <button type="button" style="display: none;" class="button-link" id="live-chat-online" (click)="startChat()">
            <fa-icon [icon]="faComments" aria-hidden="true"></fa-icon> Live Chat
        </button>
        <span id="live-chat-offline"><fa-icon [icon]="faComments" aria-hidden="true"></fa-icon> Live Chat</span>
    </span>

    <button [hidden]="!isSwitchUrlAvailable()" type="button" class="button-link" (click)="switchEnvUrl()">Switch URL</button>

</div>

@if (showTermsOfService()) {
    <app-dialog dialogId="terms-of-service" heading="Terms & Conditions">
        <ng-template>
            <app-terms-of-service></app-terms-of-service>
        </ng-template>
    </app-dialog>
}

<app-dialog dialogId="account-security-update"
            heading="Account Security Update"
            size="lg" closable="false">
    <ng-template>
        <app-account-security-update
                [primaryEmail]="primaryEmailAddress"
                [userId]="userId"
                [showSecurityQuestions]="showSecurityQuestions"
                [showBackupEmail]="showBackupEmail"
                (accountSecurityUpdateCompleteEvent)="closeAccountSecurityUpdateDialog()"
        ></app-account-security-update>
    </ng-template>
</app-dialog>
